import RadioButton from "./RadioButton";
import InputData from "./InputData";
import ButtonIconH from "./ButtonIconH";
import { useEffect, useState } from "react";
import { focusElement } from "../js/utils";

export function DashboardStorePanelFilterSectionExport({
  onChange,
  createPopupQuestion,
  removePopupQuestion,
  onExport,
}) {
  const [fileType, setFileType] = useState(0);
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);

  const checkEmail = () => {
    if (errorEmail || email === "") {
      createPopupQuestion(
        "Por favor, introduzca un email correcto.",
        () => {
          focusElement(20);
          setErrorEmail(false);
          removePopupQuestion();
          return;
        },
        null,
        "Entendido"
      );
    } else onExport(true);
  };

  useEffect(() => {
    onChange(fileType, email);
  }, [fileType, email]);

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <div className="opt-table-title opt-table-title-dash-stats">
          Tipo de archivo
        </div>
      </div>
      <div className="opt-table-content grid-10" id="dashboard-export">
        <div className="cell">
          <RadioButton
            active={fileType === 0}
            onClick={() => {
              setFileType(0);
            }}
          ></RadioButton>
        </div>
        <div className="cell">Archivo PDF</div>
        <div className="cell"></div>
        <div className="cell">
          <RadioButton
            active={fileType === 1}
            onClick={() => {
              setFileType(1);
            }}
          ></RadioButton>
        </div>
        <div className="cell">Archivo EXCEL</div>
        <div className="cell"></div>
        <div className="cell">
          <RadioButton
            active={fileType === 2}
            onClick={() => {
              setFileType(2);
            }}
          ></RadioButton>
        </div>
        <div className="cell">Archivo CSV</div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          <ButtonIconH
            text="Exportar"
            small={true}
            onClick={() => onExport(false)}
          ></ButtonIconH>
        </div>
        <div className="cell combined-cells-2">Enviar por email</div>
        <div className="cell combined-cells-6 cell-start-content">
          <InputData
            type="type-email"
            size={0}
            input={email}
            onChange={(e) => {
              setEmail(e);
            }}
            onMalformed={() => setErrorEmail(true)}
            error={errorEmail}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          <ButtonIconH
            text="Enviar"
            small={true}
            onClick={checkEmail}
          ></ButtonIconH>
        </div>
      </div>
    </div>
  );
}
